
    import { computed, defineComponent, onBeforeMount, ref } from 'vue'

    import PostNewest from '@/app/components/common/posts/PostNewest.vue'

    import AdsContainer from '@/app/views/home/components/AdsContainer.vue'
    import Slider from '@/app/views/home/components/Slider.vue'

    import { useAdsStore } from '@/app/stores/ads'
    import { useBreadcrumbsStore } from '@/app/stores/breadcrumbs'
    import { useSlidesStore } from '@/app/stores/slides'

    import { useHeadful } from '@/common/composables/libs/headful'
    import { useI18n } from 'vue-i18n-composable'
    import { usePostsStore } from '@/app/stores/posts'
    import { useSharedSettingsStore } from '@/common/stores/shared-settings'

    export default defineComponent({
        components: {
            AdsContainer,
            PostNewest,
            Slider
        },
        setup () {
            const headful = useHeadful()
            const i18n = useI18n()
            const adsStore = useAdsStore()
            const postsStore = usePostsStore()
            const settingsStore = useSharedSettingsStore()
            const slidesStore = useSlidesStore()

            const maximumLoads = 3
            const currentLoads = ref(0)

            const ads = computed(() => adsStore.ads)
            const loading = computed(() => postsStore.loading)
            const posts = computed(() => postsStore.data.data)
            const slides = computed(() => slidesStore.slides)

            const canLoadMore = computed(() => currentLoads.value < maximumLoads)
            const maxAds = computed((): number => {
                const value = settingsStore.setting('home-ads-count')

                return value === '' ? 4 : parseInt(value, 10)
            })

            const loadMore = async (): Promise<void> => {
                await postsStore.loadNext()
                currentLoads.value++
            }

            onBeforeMount(async (): Promise<void> => {
                useBreadcrumbsStore().reset()

                headful({
                    title: i18n.t('meta.title').toString()
                })

                currentLoads.value = 0

                await adsStore.load()
                await postsStore.load()
                await slidesStore.load()

                if (!settingsStore.loaded) {
                    await settingsStore.load()
                }
            })

            return {
                ads,
                canLoadMore,
                loading,
                maxAds,
                posts,
                slides,
                loadMore
            }
        }
    })
